// src/utils/levelManager.js
const LEVEL_FACTOR = 400;
const BASE_XP = 500;
const levelThresholds = [0];

export function getXpForLevel(level) {
  if (level <= 1) return 0;
  // Рассчитываем порог XP для достижения определенного уровня
  if (levelThresholds[level - 1]) {
    return levelThresholds[level - 1];
  }
  
  let totalXp = 0;
  for (let i = 2; i <= level; i++) {
    totalXp += BASE_XP + (i - 2) * LEVEL_FACTOR;
  }
  levelThresholds[level - 1] = totalXp;
  return totalXp;
}

export function getLevelFromXp(xp) {
  if (xp < BASE_XP) return 1;
  let level = 2;
  while (true) {
    const xpNeeded = getXpForLevel(level + 1);
    if (xp < xpNeeded) {
      return level;
    }
    level++;
  }
}